export interface PlayRequest {
  source: string;
  track: number;
  volume?: number;
  promiseResolve?: (any) => void;
  promiseReject?: (any) => void;
  audio?: HTMLAudioElement;
  endCallback?: (any) => void;
}

export enum PlayResult {
  success = 'success',
  resumed = 'resumed',
  interrupted = 'interrupted',
  paused = 'paused',
  stopped = 'stopped',
  notFound = 'not-found',
  error = 'error',
}
